import { Box, Button } from "@mui/material"
import { Icon } from "@iconify/react"
import { handleDownload } from "routes/sfg20-admin/plugins/system-info/common/handle-download"

export function DownloadButton({ data, columns, title }) {
    return (
        <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
                startIcon={<Icon icon="ic:baseline-download" />}
                onClick={() => {
                    handleDownload(data, columns, title)
                }}
                variant="outlined"
            >
                Download {title}
            </Button>
        </Box>
    )
}
